import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "ItemBase__StyledItem",
  componentId: "components-web__sc-o0oiv5-0"
})({
  display: 'flex'
});
const Item = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledItem, {
    ...rest,
    children: children
  });
};
Item.propTypes = {
  /**
   * Item content
   */
  children: PropTypes.node.isRequired
};
export default Item;